<template>
  <div class='h-mml-inlineblock'>
    <ejs-dropdownlist
      :dataSource='vals'
      :fields='fields'
      :field='field'
      :name='field.name'
      :allowCustom='allowCustom'
      :enabled='!field.disabled'
      :placeholder='field.placeholder'
      v-model='value'
      @select='selectChanged'
        width='80%'>
    </ejs-dropdownlist>
    <div v-show='field.showCheckbox' class='h-mml-chkbox-inlineblock'>
      <ejs-checkbox :checked='checked' v-model='checked' v-show='field.showCheckbox'></ejs-checkbox>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import packageParams from '@/components/mmlconfig/mixins/packageParams';

const { mapGetters } = createNamespacedHelpers('mmlconfig');
export default {
  name: 'form-select',
  mixins: [packageParams],
  props: {
    field: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      fields: { text: 'name', value: 'value' },
      allowCustom: true,
      checked: false,
      vals: this.field.vals,
      value: this.field.def,
    };
  },
  watch: {
    value(newVal) {
      this.$parent.dataCache[this.field.name] = newVal;
      this.field.def = newVal;
    },
    'field.def'(newVal) {
      if (newVal !== this.value) {
        this.value = newVal;
      }
    },
    'field.vals'(newVal) {
      this.vals = newVal;
    },
    checked() {
      if (!this.field.showCheckbox) {
        return;
      }
      if (this.checked) {
        this.field.disabled = false;
      } else {
        this.field.disabled = true;
      }
    },
  },
  computed: {
    ...mapGetters(['currentNode', 'currentMo']),
    fieldDef() {
      return this.field.def;
    },
  },
  created() {
    // 如果是外键，需要执行MML查询值
    if (!this.field.isForeign) {
      return;
    }
    const foreignMo = this.field.foreignKey.split(':')[0];
    const foreignAttr = this.field.foreignKey.split(':')[1];
    const cmdType = ['cluster', 'equipment', 'ne', 'short'];
    const mml = `QRY ${foreignMo} ;`;
    const data = {
      neId: this.currentNode.id,
      cmd: mml,
      timeOut: 10,
      cmdType: cmdType.indexOf(this.currentNode.nodeType)
    };
    if (this.currentNode.nodeType === 'equipment') {
      data.equipmentIpId = this.findEquipmentIpId(this.currentNode, this.currentMo);
    }
    const fkVals = [];
    if (this.field.validate && !this.field.validate.includes('required')) {
      fkVals.push({ name: '', value: '' });
    }
    this.axios.post('/lte/ems/config/adv/executeMML', data).then(result => {
      const resultData = result.data.resultVal.data;
      if (resultData.result === 'FAIL') {
        // 弹出提示框
      }
      if (resultData.result === 'OK') {
        const fkMoArr = resultData.data;
        if (!fkMoArr || fkMoArr.length <= 0) { return; }
        fkMoArr.forEach(fkMo => {
          if (fkMo[foreignAttr]) {
            const temp = {
              name: fkMo[foreignAttr],
              value: fkMo[foreignAttr],
            };
            if (!JSON.stringify(fkVals).includes(JSON.stringify(temp))) {
              fkVals.push(temp);
            }
          }
        });
        console.log('fkVals', this.field);
        this.vals = fkVals;
      }
    });
  },
  methods: {
    selectChanged(args) {
      // this.$parent.dataCache[this.field.name] = args.value;
      const fieldVal = args.itemData.value;
      this.$emit('update-data-cache', this.field.name, fieldVal);
      if (typeof (this.field.func) === 'function') {
        this.field.func();
      }
      if (typeof (this.field.pkfunc) === 'function') {
        this.field.pkfunc(this.field.name, fieldVal);
      }
    },
  },
};
</script>

<style>

</style>
